import { RouteConfig } from 'config/constants/route'
import { SocialTaskBonusEnums } from 'config/types/bonus/socialTaskBonus'
import { usePrivateSocket } from 'hooks/usePrivateSocket'
import { useEffect } from 'react'
import { useAppDispatch } from 'state'
import { updateTelegramId } from 'state/auth/action'
import { useAuth } from 'state/auth/hooks'
import { useReceiveSocialTaskBonuses } from 'state/bonus/hooks/useReceiveSocialTaskBonuses'
import { useSocialTaskBonuses } from 'state/bonus/hooks/useSocialTaskBonuses'
import { updateUserLinkTelegram } from 'state/profile/actions'

export const useListenerLinkedTelegram = () => {
  const socket = usePrivateSocket()
  const dispatch = useAppDispatch()
  const { isSigned } = useAuth()
  const { handleReceiveSocialBonus } = useReceiveSocialTaskBonuses([RouteConfig.BonusCenter])
  const socialTaskBonuses = useSocialTaskBonuses()

  const handleLogin = async (data) => {
    dispatch(
      updateUserLinkTelegram({
        id: data.id,
        username: data.username || '',
        connected: true,
      }),
    )
    dispatch(updateTelegramId(data.id))
  }

  useEffect(() => {
    if (!socket) {
      return
    }

    const event = socket.on('auth.telegram.connected', (data) => {
      if (data.id) {
        handleLogin(data)
        handleReceiveSocialBonus(SocialTaskBonusEnums.ConnectTelegram)
      }
    })

    return () => {
      event.off()
    }
  }, [isSigned, socket, socialTaskBonuses])
}
